import { useMaterialUIController } from "context";
import DataTable1, { createTheme } from "react-data-table-component";
import { useSelector } from "react-redux";
import { TableLoadingRows } from "components/BTable/BTable";

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "var(--surface-primary, #191b1f)",
    },
    context: {
      background: "var(--surface-primary, #191b1f)",
      text: "white",
    },
    divider: {
      default: "white",
    },
    button: {
      default: "#2aa198",
      hover: "rgba(0,0,0,.08)",
      focus: "rgba(255,255,255,.12)",
      disabled: "rgba(255, 255, 255, .34)",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    button: {
      default: "#2aa198",
      hover: "rgba(0,0,0,.08)",
      focus: "rgba(255,255,255,.12)",
      disabled: "rgba(255, 255, 255, .34)",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);

function NewDataTable({ ...props }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const globalLoading = useSelector((state) => state.loader.isLoading);
  const tableLoading =
    props.loading !== undefined ? props.loading : globalLoading;
  // const tableCustomStyles = {
  //   headRow: {
  //     style: {
  //       color: darkMode ? "white" : "black",
  //       backgroundColor: darkMode ?"var(--surface-primary, #191b1f)":"white",
  //     },
  //   },
  //   rows: {
  //       style: {
  //           color: darkMode ? "white" : "black",
  //           backgroundColor: darkMode ?"var(--surface-primary, #191b1f)":"white",
  //           '&:hover': {
  //               color: darkMode ? "black" : "black",
  //           backgroundColor: darkMode ?"var(--surface-primary, #191b1f)":"white",
  //             },
  //       },
  //   striped: {

  //     color: darkMode ? "white" : "black",
  //       backgroundColor: darkMode ?"var(--surface-primary, #191b1f)":"white",
  //   }},
  //   footerRow:{

  //   }
  // };
  return (
    <DataTable1
      theme={darkMode ? "solarized" : "light"}
      // title="Select Item"
      columns={props.columns}
      data={props.data}
      progressPending={tableLoading}
      progressComponent={<TableLoadingRows />}
      defaultSortFieldId={props.defaultSortFieldId}
      pagination={props.pagination}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10]}
      highlightOnHover={props.highlightOnHover}
      noDataComponent="No records found"
      selectableRows={props.selectableRows}
      onSelectedRowsChange={props.onSelectedRowsChange}
      // customStyles={tableCustomStyles}
      fixedHeader={props.fixedHeader}
      selectableRowDisabled={props.selectableRowDisabled}
      conditionalRowStyles={props.conditionalRowStyles}
      fixedHeaderScrollHeight={props.fixedHeaderScrollHeight}
    />
  );
}

export default NewDataTable;
